import React, { useEffect, useState } from "react";
import VerifyEmailMobile from "./VerifyEmailMobile";
import axios from "../../axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
export default function EnterEmailOtp({
  studentDetails,
  setEmailPhoneVerification,
  emailPhoneVerification,
  setVerify,
  setRegister,
  setIsInProgress,
  inputValue,
  inputSchoolCode,
  maskPhoneNumber,
  MaskedEmail
}) {
  //Here increase the minute limit
  const [minutes, setMinutes] = useState(2);
  //Here increase the second limit
  const [seconds, setSeconds] = useState(60);
  const [isInProgress1, setIsInProgress1] = useState(false);
  const [invalidOtp, setInvalidOtp] = useState();

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(60);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const resendOTP = () => {
    handleEmailOtpResend();
    setEmailPhoneVerification({
      ...emailPhoneVerification,
      enterEmailOtp: "",
    });
    setInvalidOtp(null);
    //Here increase the minute limit
    setMinutes(2);
    //Here increase the second limit
    setSeconds(60);
  };

  function handleOtpChange(e) {
    const value = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    setEmailPhoneVerification({
      ...emailPhoneVerification,
      enterEmailOtp: value,
    });
  }

  const handleEmailOtpResend = async () => {
    try {
      await axios.post(`/studentAuth/generateEmailOtp`, {
        unique_id: inputValue,
        school_code: inputSchoolCode
      });
    } catch (error) {
      console.log(error);
    }
  };

  const validateEmailOtp = async () => {
    setIsInProgress1(true);
    try {
      let res = await axios.post(`/studentAuth/validateEmailOtp`,
        {
          unique_id: inputValue,
          school_code: inputSchoolCode,
          otp: emailPhoneVerification?.enterEmailOtp
        });
      res &&
        setEmailPhoneVerification({
          ...emailPhoneVerification,
          verifiedEmail: true,
        });
    } catch (error) {
      setInvalidOtp(error.response.data.message);
      setIsInProgress1(false);
      console.log(error);
    }
  };



  return (
    <div>
      {!emailPhoneVerification.verifiedEmail && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <>
                <div
                  className="backLoginIcon"
                  onClick={(e) => setVerify((prev) => ({ ...prev, verifyEmail: false }))}
                >
                  {/* Insted of image add I added icon */}
                  <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: "25px", }} />

                </div>

                <div className="InsideDetailCpntainer" style={{ width: "45%" }}>
                  <div className="d-flex justify-content-center">
                    <img
                      className="registrationIcon"
                      src="/StudentImg/BreathSchoolLogo.png"
                      alt="icon"
                    />
                  </div>
                  <div className="d-flex justify-content-center headerEnterOtp mt-3">
                    Enter OTP
                  </div>
                  <div className="OtpEmailId text-center">
                    {studentDetails?.mobileNumber || studentDetails?.email ? (
                      <>
                        An OTP has been sent to{' '}
                        {studentDetails?.mobileNumber && (
                          <>
                            your WhatsApp number{' '}
                            <span className="font-medium">
                              +91 {maskPhoneNumber(studentDetails?.mobileNumber)}
                            </span>
                          </>
                        )}
                        {studentDetails?.mobileNumber && studentDetails?.email && ' and '}
                        {studentDetails?.email && (
                          <>
                            your email{' '}
                            <span className="font-medium">{MaskedEmail(studentDetails?.email)}</span>
                          </>
                        )}

                        .<br /> Please enter the code to proceed.
                      </>
                    ) : (
                      'Mobile number and Email id are not registered.'
                    )}
                  </div>

                  <div className="d-flex justify-content-between p-3 align-items-center registrationUserInput-pin  mt-4">
                    <input
                      id="otpInput"
                      type="text"
                      maxLength="6"
                      pattern="[0-9]*"
                      value={emailPhoneVerification?.enterEmailOtp}
                      onChange={handleOtpChange}
                      placeholder="Enter OTP"
                      autoComplete="off"
                    />
                    <span className="otp_timer_count">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mt-3">
                    <div>
                      {(minutes === 0 && seconds === 0 && !invalidOtp) ?
                        <div className="invailidOtp ">Time out!</div>
                        : invalidOtp &&
                        <div className="invailidOtp ">invalid OTP entered</div>
                      }
                    </div>
                    <div className="d-flex justify-content-end ">
                      <button
                        className="Resend_otp_email"
                        disabled={seconds > 0 || minutes > 0}
                        style={{
                          color:
                            seconds > 0 || minutes > 0 ? "#DFE3E8" : "#F77F00",
                          borderBottom: seconds > 0 || minutes > 0 ? "1px solid #DFE3E8" : "1px solid #F77F00",
                        }}
                        onClick={resendOTP}
                      >
                        Resend OTP
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-2">
                    <button
                      type="submit"
                      disabled={
                        !emailPhoneVerification.enterEmailOtp || isInProgress1 || seconds === 0 && minutes === 0
                      }
                      onClick={validateEmailOtp}
                      className="RegisterBtn2"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      )}

      {emailPhoneVerification?.verifiedEmail && (
        <VerifyEmailMobile
          studentDetails={studentDetails}
          emailPhoneVerification={emailPhoneVerification}
          setEmailPhoneVerification={setEmailPhoneVerification}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
    </div>
  );
}
